<template>
  <div class="receipt-preview-wrapper">
    <div
      :class="['receipt-preview-inner', `paper-size-${paperSize}`]"
    >
      <!-- Using for preview -->
      <receipt-view
        :shop_logo="receiptReviewInfo.shopLogo"
        :shop_name="receiptReviewInfo.shopName"
        :shop_address="receiptReviewInfo.shopAddress"
        :shop_tax_id="receiptReviewInfo.shopTaxId"
        :shop_tax_title="receiptReviewInfo.shopTaxTitle"
        :shop_tel="receiptReviewInfo.shopTel"
        :orders="receiptReviewInfo.orders"
        :total_price="receiptReviewInfo.totalPrice"
        :receipt_info="receiptReviewInfo.receiptInfo"
        :date_time="receiptReviewInfo.dateTime"
        :text_footer="receiptReviewInfo.textFooter"
        :font_size="fontSize"
      />
    </div>
    <div class="mt-5">
      <button
        class="btn btn-ligth"
        @click="onPrint">
        <span>
          {{ $t('apps.pos.button.testprintreceipt') }}
        </span>
        <i class="fas fa-print"/>
      </button>
    </div>
  </div>
</template>

<script>
import receiptView from '@/components/custom/print/pos/Receipt.vue'

export default {
  components: {
    receiptView,
  },
  props: {
    receiptReviewInfo: {
      type: Object,
    },
    paperSize: {
      type: String,
    },
    fontSize: {
      type: Number,
      default: () => 100,
    },
  },
  methods: {
    onPrint () {
      this.$emit('onPrint')
    },
  },
}
</script>

<style scoped>
.receipt-preview-wrapper {
  background-color: rgb(239, 239, 239);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0 50px 0;
}

.receipt-preview-inner {
  padding: 15px 0 20px 0;
  background-color: #fff;
  zoom: 1.5;
}

.receipt-preview-inner.paper-size-58mm {
  width: 58mm;
}

.receipt-preview-inner.paper-size-80mm {
  width: 80mm;
}

.btn-ligth {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BasePosReceiptPreview.vue